import React from 'react';
import { connect } from 'react-redux';
import Login from '../Login/Login';
import SupportTeam from '../SupportTeam';
import DailyNotes from './DailyNotes';
import Specials from './Specials';
import QuickLinks from './QuickLinks';
import Banner from './Banner';
import Notices from './Notices';
import { CopyGroupDropdown } from './CopyGroupDropdown';
import { withRouter, Prompt } from 'react-router-dom';
import { actionCreators } from '../../store/Login';
import { bindActionCreators } from 'redux';
import { PageHeader, PageHeaderRight } from '../shared/PageHeader';
import { toast } from 'react-toastify';
import { BlankOrderGuideGroup } from '../shared/consts';

export class Home extends React.Component {
    displayName = Home.name;

    constructor(props) {
        super(props);
        this.state = {
            isDirtyDailyNotes: false,
            isDirtySpecials: false,
            isDirtyQuickLinks: false,
            isDirtyNotices: false,
            isDirtySupportTeam: false,
            isCopyHome: false,
            toCopyBanner: null,
            toCopyDailyNotes: null,
            toCopySpecials: null,
            toCopyNotices: null,
            toCopyQuickLinks: null,
            copyOrderGuideGroupId: null,
            orderGuideGroupId: undefined,
            orderGuideGroup: BlankOrderGuideGroup
        };
    }


    componentDidMount = async () => {
        this.setState({ loading: true });

        try {
            const fetchConfig = {
                method: 'GET', headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
            };
            const response = await fetch('api/OrderGuideGroups/settings', fetchConfig);
            if (response.ok) {
                let data = await response.json();

                this.setState({
                    orderGuideGroup: data.orderGuideGroup,
                    orderGuideGroupId: data.orderGuideGroup.orderGuideGroupId
                });
            }
            else {
                this.setState({ responseStatus: response.status });
                if (this.props.isAuthenticated) {
                    // only show this if we aren't trying to login at the time
                    toast.error("Unable to load Order Guide settings.");
                    console.log("Unable to load Order Guide settings: " + response.text());
                }
            }

        } catch (e) {
            console.log("Error in componentDidMount.");
            console.log(e);
        }

        this.setState({ loading: false });
    }

    setIsDirtyDailyNotes = (dirty) => {
        this.setState({ isDirtyDailyNotes: dirty });
    }
    setIsDirtySpecials = (dirty) => {
        this.setState({ isDirtySpecials: dirty });
    }
    setIsDirtyQuickLinks = (dirty) => {
        this.setState({ isDirtyQuickLinks: dirty });
    }
    setIsDirtyNotices = (dirty) => {
        this.setState({ isDirtyNotices: dirty });
    }
    setIsDirtySupportTeam = (dirty) => {
        this.setState({ isDirtySupportTeam: dirty });
    }

    copyHomeScreen = () => {
        this.setState({ isCopyHome: true, isEditHome: false });
    }

    cancelHomeCopy = () => {
        this.setState({ isCopyHome: false });
    }

    toggleAddToCopyHome = (section, item, e) => {
        switch (section) {
            case 'banner':
                this.setState({ toCopyBanner: item });
                break;
            case 'dailyNotes':
                this.setState({ toCopyDailyNotes: item });
                break;
            case 'specials':
                this.setState({ toCopySpecials: item });
                break;
            case 'notices':
                this.setState({ toCopyNotices: item });
                break;
            case 'quickLinks':
                this.setState({ toCopyQuickLinks: item });
                break;
            default: break;
        }
    }

    mergeCopyHomeScreen = async () => {
        if (!this.state.copyOrderGuideGroupId  || this.state.copyOrderGuideGroupId === "") {
            toast.warn("Select a guide to copy to.");
            return;
        }

        toast.warn("Processing merge request...", { autoClose: 10000, hideProgressBar: false });

        var data = {
            "CopyOrderGuideGroupId": this.state.copyOrderGuideGroupId,
            "Banner": this.state.toCopyBanner,
            "DailyNotes": this.state.toCopyDailyNotes,
            "Specials": this.state.toCopySpecials,
            "Notices": this.state.toCopyNotices,
            "QuickLinks": this.state.toCopyQuickLinks
        };

        const fetchConfig = {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(data)
        };

        const response = await fetch('api/home/mergehomepage/', fetchConfig);
        if (response.ok) {
            toast.dismiss();
            toast.success("Merge home page completed.");

            this.setState({ isCopyHome: false });
        }
        else if (response.status === 401) {
            toast.dismiss();
            toast.error("Unauthorized.");
            this.props.signOut();
        }
        else {
            toast.dismiss();
            toast.error(`Error merging home page.`);
            console.log(`Error merging home page: ${await response.text()}.`);
        }
    }

    replaceCopyHomeScreen = async () => {
        if (!this.state.copyOrderGuideGroupId || this.state.copyOrderGuideGroupId === "") {
            toast.warn("Select a guide to copy to.");
            return;
        }

        toast.warn("Processing replace request...", { autoClose: 10000, hideProgressBar: false });

        var data = {
            "CopyOrderGuideGroupId": this.state.copyOrderGuideGroupId,
            "Banner": this.state.toCopyBanner,
            "DailyNotes": this.state.toCopyDailyNotes,
            "Specials": this.state.toCopySpecials,
            "Notices": this.state.toCopyNotices,
            "QuickLinks": this.state.toCopyQuickLinks
        };

        const fetchConfig = {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(data)
        };

        const response = await fetch('api/home/replacehomepage/', fetchConfig);
        if (response.ok) {
            toast.dismiss();
            toast.success("Replace home page completed.");

            this.setState({ isCopyHome: false });
        }
        else if (response.status === 401) {
            toast.dismiss();
            toast.error("Unauthorized.");
            this.props.signOut();
        }
        else {
            toast.dismiss();
            toast.error(`Error replacing home page.`);
            console.log(`Error replacing home page: ${await response.text()}.`);
        }
    }

    changeGuide = async (event) => {
        await this.setState({ copyOrderGuideGroupId: event.target.value });
    }

    render() {        
        if (!this.props.isAuthenticated) {         
            return <Login />;
        }

        return (
            <div>
                {this.props.isEditHome && this.props.userRole !== "GroupStoreBuyer" &&
                    <PageHeader pageTitle="Edit Home"
                        pageHeaderRight={
                            <PageHeaderRight>       
                                {!this.state.isCopyHome &&
                                    <input type="button" className="ogcButton" onClick={this.copyHomeScreen} value="Copy Home Screen" />
                                }
                                {this.state.isCopyHome &&
                                    <React.Fragment>
                                        <span>{this.state.orderGuideGroup.orderGuideGroupName} >> </span>
                                        {!this.state.loading &&
                                            <CopyGroupDropdown onChange={this.changeGuide}
                                                value={this.state.orderGuideGroupId}
                                                name="orderGuideGroupId"
                                                orderGuideGroupId={this.state.orderGuideGroupId}
                                            />
                                        }
                                    <input
                                        type="button"
                                        className="ogcButton"
                                        onClick={this.mergeCopyHomeScreen}
                                        value="Merge Selected"
                                    />
                                        <input type="button" className="ogcButton" onClick={this.replaceCopyHomeScreen} value="Replace Selected" />
                                        <input type="button" className="ogcButton ogcButton-brown btn-std-size"  onClick={this.cancelHomeCopy} value="Cancel" />
                                    </React.Fragment>
                                }
                            </PageHeaderRight>
                        }
                    />
                }
                <div>
                    <Banner
                        isEditHome={this.props.isEditHome}
                        isCopyHome={this.state.isCopyHome}
                        toggleAddToCopyHome={this.toggleAddToCopyHome}
                    />
                </div>
                <div className="row d-flex d-lg-block">
                    <div className="col-sm-7 order-1 homeCol1" >
                        <DailyNotes
                            isEditHome={this.props.isEditHome}
                            isCopyHome={this.state.isCopyHome}
                            toggleAddToCopyHome={this.toggleAddToCopyHome}
                            setDirty={this.setIsDirtyDailyNotes}
                            isDirty={this.state.isDirtyDailyNotes}
                        />
                        <Specials
                            isEditHome={this.props.isEditHome}
                            isCopyHome={this.state.isCopyHome}
                            toggleAddToCopyHome={this.toggleAddToCopyHome}
                            setDirty={this.setIsDirtySpecials}
                            isDirty={this.state.isDirtySpecials}
                        />
                    </div>
                    <div className="col-sm-5 order-2 homeCol2" >
                        <br/>
                        <QuickLinks
                            isEditHome={this.props.isEditHome}
                            isCopyHome={this.state.isCopyHome}
                            toggleAddToCopyHome={this.toggleAddToCopyHome}
                            setDirty={this.setIsDirtyQuickLinks}
                            isDirty={this.state.isDirtyQuickLinks}
                        />
                        <Notices
                            isEditHome={this.props.isEditHome}
                            isCopyHome={this.state.isCopyHome}
                            toggleAddToCopyHome={this.toggleAddToCopyHome}
                            setDirty={this.setIsDirtyNotices}
                            isDirty={this.state.isDirtyNotices}
                        />
                    </div>
                    <div className="col-sm-12">
                        <SupportTeam
                            isEditHome={this.props.isEditHome}
                            isCopyHome={this.state.isCopyHome}
                            setDirty={this.setIsDirtySupportTeam}
                            isDirty={this.state.isDirtySupportTeam}
                        />
                    </div>
                </div>
                <Prompt when={this.state.isDirtyDailyNotes || this.state.isDirtySpecials || this.state.isDirtyQuickLinks ||
                        this.state.isDirtyNotices || this.state.isDirtySupportTeam}
                    message="Changes to this Home page will be lost. Continue?"
                />
            </div>
        );    
    }
}

export default withRouter(connect(state => state.login,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(Home));


// WEBPACK FOOTER //
// ./src/components/Home/Home.js